import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RecentResultsItemType, RecentResultsType } from '../../../api/recentResults';
import { fetchRecentResultsAction } from '../../apiActions/fetchRecentResultsAction';
import { RecentResultTypePercentage } from '../../../api/recentResultPercentage';
import { fetchRecentResultsPercentageAction } from '../../apiActions/fetchRecentResultsPercentageAction';

const initialState: {
  recentResultsCount: number;
  recentResults: RecentResultsType | null ;
  recentResultPercentage: RecentResultTypePercentage | null;
} = {
  recentResultsCount: 500,
  recentResults: null,
  recentResultPercentage: null,
};

export const mwGameStateSlice = createSlice({
  name: 'mwGameState',
  initialState,
  reducers: {
    setRecentResultsCount: (state, action: PayloadAction<number>) => {
      state.recentResultsCount = action.payload;
    },
    prependRecentResult: (state, action: PayloadAction<RecentResultsItemType>): void => {
      const history = state.recentResults?.history;
      if (history && history[0]?.gameId !== action.payload.gameId) {
        history.unshift(action.payload);
        history.length > state.recentResultsCount && history.pop();
      }
    },
    setResultPercentage:(state,action):void=>{
      state.recentResultPercentage={...state.recentResultPercentage,betResultStats:{...action.payload}}; 
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRecentResultsAction.fulfilled, (state, action) => {
        state.recentResults = action.payload;
      })
      .addCase(fetchRecentResultsPercentageAction.fulfilled, (state, action) => {
        state.recentResultPercentage = action.payload;
      });
  },
});

export const mwGameStateActions = mwGameStateSlice.actions;
